<template>
  <div class="casedetailsContent">
    <div class="imgText">
      <img src="../../assets/img/main/lun2.png" alt="" />
    </div>
    <div class="titleh">
      <h1 style="color:#333;font-weight:700;">案例详情</h1>
    </div>
    <div class="textli wl">
      <img src="../../assets/img/card.png" alt="" class="conimgra"/>
      <div>
        <div class="textfont wids">{{ start }}|{{ end }}</div>
        <div style="font-weight:400;margin-top:4px;font-size:12px;">
          {{ time }}
        </div>
      </div>
    </div>
    <div class="casedetailsTitle">
      <div class="text_title">
        <div class="textfont" style="font-weight:700;"><span class="pic"></span><span>项目背景</span> </div>
        <div>
          <ul>
            <li
              v-for="(item, index) in context"
              class="listfonts"
              :key="index"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>
        <div class="textfont" style="font-weight:700;"><span class="pic"></span><span>客户需求</span> </div>
        <div>
          <ul>
            <li
              v-for="(item, index) in costomer"
              class="listfonts"
              :key="index"
            >
              {{ item.title }}
            </li>
          </ul>
          <div style="text-align:left;">
             <img src="../../assets/img/main/lun2.png" alt="" style="width:400px;height:200px;margin-top:20px;margin-left:30px;">
          </div>
        </div>
        <div class="textfont" style="font-weight:700;"><span class="pic"></span><span>解决方案</span> </div>
        <div>
          <ul>
            <li
              v-for="(item, index) in solution"
              class="listfonts"
              :key="index"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      start: "麦当劳",
      end: "腾讯云2条30M专线",
      time: "2019-12-34",
      context: [
        {
          title:
            "麦当劳全国3000多家门店网银支付系统的使用"
        },
        // {
        //   title:
        //     "1.客户端比目鱼创业园C座多联元机房，需要分别接入北京腾讯云德信和航信节点"
        // },
        // {
        //   title:
        //     "1.客户端比目鱼创业园C座多联元机房，需要分别接入北京腾讯云德信和航信节点"
        // }
      ],
      costomer: [
        {
          title:
            "1.客户端Hogon SH3机房，需要分别接入上海腾讯云腾讯大厦和斜土路接入点"
        },
        {
          title:
            "2.2条链路需要全程异路由，分别接入不同CE设备"
        },
        {
          title:
            "3.要求2条线路做主备链路，对线路主备切换要求较高"
        }
      ],
      solution: [
        {
          title:
            "1.从客户Hogon SH3机柜下2条跳线接入天弛PE节点"
        },
        {
          title:
            "2.天弛网络提供两条异路由线路分别接入天弛腾讯大厦PE和天弛斜土路PE节点；"
        },
        {
          title:
            "3.客户端机柜放置2台cisco设备做为CE接入路由器，做主备配置和监控机制"
        },
         {
          title:
            "4.腾讯云2个端口做路由设置关联主备端口，2台CE路由器用BFD方式配合腾讯云端口做主备切换。主线路中断时，客户无需做任何手动操作，业务自动从主线路切换到备用线路上"
        }
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
.casedetailsContent {
  position: relative;
  color:#333;
  .imgText {
    width: 100%;
    height: 500px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .titleh{
    position: absolute;
    top: 18%;
    margin-left: 120px;
  }
  .textli {
    font-size: 22px;
    font-weight: 700;
    margin-top: 30px;
    padding-bottom: 5px;
    display: flex;
    border-bottom:1px solid #ccc;
    position: absolute;
    top: 20%;
    margin-left: 280px;
    img {
      margin-right: 10px;
    }
    .wids {
      width: 500px;
    }
  }
  .casedetailsTitle {
    display: flex;
    justify-content: center;
    
    .pic {
      border: 2px solid #248f47;
      vertical-align: middle;
      margin-right:10px;
    }
    .text_title {
      margin: 20px 0;
      .textfont {
        margin-top: 30px;
        margin-bottom: 20px;
        text-align: left;
        vertical-align: middle;
      }
      /* 客户案例字体 */
      .listfonts {
        font-size: 14px;
        color: #666666;
        width: 60%;
        line-height: 2;
        margin-left: 30px;
        text-align: left;
      }
    }
  }
}
</style>
